//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { useState, useEffect, useMemo, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Title } from "@vds/typography";
import { Button } from "@vds/buttons";
import { Box } from "@mui/system";

import {
  Base64ImageDecoder,
  Base64VideoDecoder,
  getPriorityColor,
  getStatusColor,
  updateSelectedIncident,
  convertDateFormat,
  getCVAppNameFromApplicationId,
  getImageObj,
  fetchEvidenceDetails,
  fetchEvidenceS3Url,
} from "../../global/utility/Utils";
import { isS3UrlValid } from "../../pages/HistoricalSearch/ForensicSearchUtil";
import { checkForEvidenceStatus, getNotificationBannerTitle, 
  getNotificationBannerType, incidentCreatedFromNow } from "../../global/utility/incidentsUtils";
import { Badge } from "@vds/badges";
import ResolveEvents from "./Modals/ResolveEvents";
import ShareEvents from "../../global/components/Modals/ShareEvents";
import { getCamerabyId } from "../../model/reportService";
import { fetchIncidentActivity, fetchSingleIncidentById } from "../../model/eventService";

import brokenImage2 from "../../images/brokenImage2.jpg";
import { useDispatch, useSelector } from "react-redux";
import { Container1, Container2, Container3, Container4, Container5, ResponsiveGrid } from "../../global/components/events/styles";
import { ImageDownloadMedia } from "../../model/mediaService";
import { UUID_REGEX } from "../../global/constants/routesConstants";
import EbcFloorPlan from "../../global/components/floorPlan/EbcFloorPlan";
import { saveFloorImageMapping, showNotificationBanner, saveEvidenceImage, saveEvidenceVideoUrl } from "../../store/actions";
import { hasPermission } from "../../global/utility/permissionUtils";
import { getValue } from "../../global/components/Modals/AdvancedConfiguration/MainSection";
import AccordionDetails from "./Components/AccordionDetails";
import EventInfoContainer from "./Components/EventInfoContainer";
import ActivityLogContainerComponent from "./Components/ActivityLogContainerComponent";
import EvidenceAndLiveFeedPlayer from "./Components/EvidenceAndLiveFeedPlayer";
import { Loader } from "@vds/loaders";
import { Notification } from "@vds/notifications";
import { getcvAppName } from "../../global/utility/cvAppUtils";
import { CVAPP_PERSON_DETECTION, CVAPP_VEHICLE_DETECTION } from "../../global/constants/cvappConstants";
import { EVENTS_INFO_CONSTANTS, HTTP_STATUS_CODES } from "../../global/constants/constants";
import { EVENT_TYPES, MEDIA_TYPES } from "../../global/constants/commonConstants";
import { set } from "date-fns";
import { TEXT } from "../../global/constants/errorTemplateConstants";
import ErrorTemplate from "../../global/components/errorTemplate/ErrorTemplate";
import { handleApiError } from "../../global/utility/Utils";
import moment from "moment";
import { getFovObjWithStreamId } from "../../global/utility/deviceTableUtils";
import "./index.scss";
const EventsInfo = (props) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const { cameraList, fovList, companionDeviceList } = useSelector((state) => state?.deviceReducer);
  // const allEventsData = useSelector((state) => state.eventReducer.allEvents);
  const floorImages = useSelector((state) => state.imagesReducer.floorImages);
  const evidenceImages = useSelector((state) => state.imagesReducer.evidenceImages);
  const evidenceVideoUrls = useSelector((state) => state.imagesReducer.evidenceVideoUrls);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  const [stateData, setStateData] = useState("");
  const evidenceData = stateData?.evidence;
  const fieldsData = stateData ? stateData?.fields : {};
  let ApplicationId = stateData?.applicationId;
  const CreatedAt = stateData?.createdAt;
  const Priority = stateData?.priority;
  const incidentId = stateData?.id;
  const activityInfo = stateData?.activity;
  const floorId = stateData?.deviceLoc?.floor?.tag;
  const title = stateData?.incident?.title;
  const [showResolveEvents, setShowResolveEvents] = useState({ isOpen: false });
  const [evidenceImage, setEvidenceImage] = useState({
    mediaType: "",
    mediaUrl: ""
  });
  const [evidenceVideo, setEvidenceVideo] = useState({
    mediaType: "",
    mediaUrl: ""
  });
  // const [evidenceid, setEvidenceid] = useState("");
  // const isCameraInBreadcrum = props.selectedCameraViewData == undefined ? true : false;
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [eventStatus, setEventStatus] = useState();
  const [unNotifiedGroups, setUnNotifiedGroups] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [userList, setUserList] = useState([]);
  const [incidentActivity, setIncidentActivity] = useState([]);
  const [resolved, setResolved] = useState(null);
  const [acknowledged, setAcknowledged] = useState(null);
  const [videoDownloaded, setVideoDownloaded] = useState(null);
  const [videoDeleted, setVideoDeleted] = useState(null);
  const [description, setDescription] = useState([]);
  const [resolveDescription, setResolveDescription] = useState(null);
  const [resolvedNote1, setResolvedNote1] = useState("");
  const [resolvedNote2, setResolvedNote2] = useState("");
  // const [downloadTime, setDownloadTime] = useState(null);
  const [incidentAction, setIncidentAction] = useState(null);
  const [others, setOthers] = useState(null);
  const [floorImage, setFloorImage] = useState(null);
  // const [imageId, setImageId] = useState(null);
  const [resolveApi, setResolveApi] = useState(null);
  const [date, setDate] = useState(null);
  const [dateTime, setDateTime] = useState(null);
  const [activityDateTime, setActivityDateTime] = useState(null);
  const [liveFeedPermitted, setLiveFeedPermitted] = useState(false);

  const { siteTagList, tagIdList } = useSelector((state) => state?.sitesReducer);
  const { cvAppList } = useSelector((state) => state?.cvAppReducer);
  const [socketImageEvidence, setSocketImageEvidence] = useState(null);
  const [socketVideoEvidence, setSocketVideoEvidence] = useState(null);

  // const [imageUrl, setImageUrl] = useState(null);
  const [appType, setAppType] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [eventNotFound, setEventNotFound] = useState(false);
  const [imageDownloadError, setImageDownloadError] = useState(false);
  const [videoDownloadError, setVideoDownloadError] = useState(false);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const incidentID = params.get("eventid");
  const [singleIncidentDetails, setSingleIncidentDetails] = useState(null);
  const cameraId = stateData?.sourceId || stateData?.evidence?.sourceId || stateData?.evidences?.[0]?.sourceId || socketImageEvidence?.sourceId;
  const newList = stateData?.deploymentConfig;
  const cvAppID = newList && newList[0]?.appid;
  const cvAppName = getCVAppNameFromApplicationId(ApplicationId, cvAppList);
  const appName = getcvAppName(cvAppList, cvAppID);
  const finalAppName = cvAppName ? cvAppName : appName;
  const isDetectionApp = finalAppName === CVAPP_PERSON_DETECTION || finalAppName === CVAPP_VEHICLE_DETECTION;
  const fovId = stateData?.fovId;
  const fovObject = getFovObjWithStreamId(fovId, fovList);
  const cameraObject = cameraList?.find((cam) => cam?.id === cameraId);
  const parentdeviceid = cameraObject && cameraObject?.parentdeviceid;
  const selCompanion = companionDeviceList?.find((item) => item?.id === parentdeviceid);
  const roiId = stateData?.roiId;
  const [incidentCreatedBefore, setIncidentCreatedBefore] = useState(0);


  // Fetch incident details if not found in allEventsData
  const fetchSingleIncidentDetails = async (incidentId, shouldUpdateSilently = false) => {
    if (activeSession && incidentId) {
      try {
        setIsError(false);
        setEventNotFound(false);
        if (!shouldUpdateSilently) {
          setLoading(true);
        }
        const response = await fetchSingleIncidentById(activeSession, incidentId);
        if (!response || !Array.isArray(response) || !Array.isArray(response[0])) {
          throw new Error("Invalid response structure");
        }
        const incident = response[0][0];
        if (incident) {
          setStateData({
            ...incident,
            evidence:
              incident.evidences && Array.isArray(incident.evidences) && getImageObj(Array.isArray(incident.evidences) ? incident.evidences : [], MEDIA_TYPES.VIDEO)
          });
          
          setIncidentCreatedBefore(moment(Date.now()).diff(moment(incident.createdAt), "minutes"));
          setEventStatus(incident.status);
          setResolveApi(incident.activity);
          const evidences = getValue(incident, "evidences");
          const imageEvidence = getImageObj(evidences, MEDIA_TYPES.IMAGE);
          setSocketImageEvidence(imageEvidence);
          const videoEvidence = getImageObj(evidences, MEDIA_TYPES.VIDEO);
          setSocketVideoEvidence(videoEvidence);
          setSingleIncidentDetails(response);
          handleEvidenceStatus(incident);
        }
      } catch (error) {
        if (error?.statusCode === HTTP_STATUS_CODES.NOT_FOUND) {
          setEventNotFound(true);
        } else {
          setIsError(true);
        }
        console.error("Error fetching single incident details:", error);
      } finally {
        setLoading(false);
      }
    }
  };


  const handleEvidenceStatus = (incident) => {
    const EVIDENCE_POLLING_THRESHOLD_HOURS = EVENTS_INFO_CONSTANTS.EVENT_CREATED_BEFORE_MONTH;
    if (incidentCreatedFromNow(incident) < EVIDENCE_POLLING_THRESHOLD_HOURS) {
        checkForEvidenceStatus(incident, timerRef, () => {
          const shouldUpdateSilently = true;
          fetchSingleIncidentDetails(incidentID, shouldUpdateSilently);
        });
      }
      if (incident?.deploymentConfig?.[0].config?.["alert-parameters"]?.["ignore_video_evidence"] && incident?.evidences?.length > 0) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        
      }
  };

  useEffect(() => {
    if (!incidentID) {
      navigate("/events");
      return;
    }
    fetchSingleIncidentDetails(incidentID);

    return () => {
      clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [incidentID]);

  const floorList = siteTagList?.floors;
  const areaName = stateData?.deviceLoc?.area?.name ? stateData?.deviceLoc?.area?.name : "NA";
  const floorName = stateData?.deviceLoc?.floor?.name ? stateData?.deviceLoc?.floor?.name : "NA";
  const siteName = stateData?.deviceLoc?.site?.name ? stateData?.deviceLoc?.site?.name : "NA";
  const [videoLoader, setVideoLoader] = useState(false);
  const [resolveEventLoader, setResolveEventLoader] = useState(false);
  const LocationName = stateData?.locationName || `${areaName}, ${floorName}, ${siteName}`;
  const liveFeedStyle = {
    width: "100%",
    height: "500px",
    position: "relative",
    overflow: "hidden"
  };
  // const knowiFullllWidgetList = JSON.parse(
  //   sessionStorage.getItem("knowiWidgetList")
  // );

  const knowiFullllWidgetList = useSelector((state) => state.statisticsReducer.widgets);
  const widgetToFilter =
    knowiFullllWidgetList?.filter((m) => {
      if (ApplicationId == "ParkingBayOccupancy") {
        return m?.name.indexOf(ApplicationId?.toLowerCase()) > -1 && m?.name.indexOf("oa_") > -1 && m?.name.indexOf("EInfo_") > -1;
      } else {
        return m?.name.indexOf(ApplicationId?.toLowerCase()) > -1 && m?.name.indexOf("EInfo_") > -1;
      }
    }) ?? [];
  const roiList = useSelector((state) => {
    return state.deviceReducer.roiList;
  });

  const appRoi = roiList?.find((m) => {
    return (
      m?.deployments != undefined &&
      m?.deployments
        ?.map((cv) => {
          return cv.id;
        })
        .indexOf(stateData?.incident?.depId) > -1
    );
  });

  var locatinTagId = "";
  if (appRoi === undefined) {
    locatinTagId =
      stateData?.deviceLoc?.subarea.tag != "NA"
        ? stateData?.deviceLoc?.subarea?.tag
        : stateData?.deviceLoc?.area.tag != "NA"
          ? stateData?.deviceLoc?.area?.tag
          : stateData?.deviceLoc?.floor?.tag;
  } else {
    locatinTagId = appRoi?.tagids && appRoi?.tagids.length ? appRoi?.tagids[appRoi?.tagids.length - 1] : "";
  }
  const getparkingCOunt = tagIdList.find((f) => {
    return f.id == locatinTagId;
  })?.parkingcount;
  locatinTagId =
    stateData?.applicationId && ApplicationId.indexOf("EE") > -1
      ? stateData?.incident?.evidences != undefined
        ? stateData?.incident?.evidences[0]?.roiId
        : stateData?.incident?.roiId
      : locatinTagId;

  //for switching tabs
  const handleTabChange = (event, newValue) => {
    setActiveTabIndex(newValue);
  };

  const NotificationDispatchContainer = ({ stateData }) => {
    const notificationInfo = {
      type: "Processing event video and snapshot",
      priority: "info",
      showNotification: true
    };
    if (stateData?.evidenceStatus === 0 && stateData?.type === EVENT_TYPES.INCIDENT) {
      dispatch(showNotificationBanner(notificationInfo));
    }
  };
  useEffect(() => {
    if (stateData?.type === EVENT_TYPES.INCIDENT) {
      setAppType("Events Apps");
      if (stateData?.evidenceStatus === 0) {
        NotificationDispatchContainer({ stateData });
      }
    } else {
      setAppType("Statistics Apps");
    }
  }, [stateData?.imageEvidence?.id, socketImageEvidence?.id, socketVideoEvidence?.id]);

  // useEffect(() => {
  //   const fetchIncidentActivity = async () => {
  //     if (incidentActivity?.length === 0) {
  //       await getIncidentActivity();
  //     }
  //   };
  //   //getKnowiencryptedHash();
  //   // fetchIncidentActivity();
  // }, [incidentActivity]);

  useEffect(() => {
    if (stateData === undefined || stateData === null) {
      navigate("/events");
    }
  }, []);

  useEffect(() => {
    const fetchFloorImage = async (id, imageId) => {
      try {
        const url = await ImageDownloadMedia(imageId, activeSession);
        setFloorImage(url || brokenImage2);
        url && dispatch(saveFloorImageMapping(id, url));
      } catch (error) {
        console.error("Error downloading image:", error);
        setFloorImage(brokenImage2);
      }
    };

    if (floorList?.length > 0) {
      if (floorId !== "") {
        floorList.forEach((f, i) => {
          if (f?.id === floorId) {
            if (f?.imageid) {
              let matchingFloorImageObj;
              if (floorImages.length) {
                matchingFloorImageObj = floorImages.find(({ id: floorId }) => floorId === f.id);
              }
              if (!matchingFloorImageObj) {
                fetchFloorImage(f.id, f?.imageid);
              } else {
                setFloorImage(matchingFloorImageObj?.imageUrl);
              }
            } else {
              setFloorImage(brokenImage2);
            }
          }
        });
      } else {
        if (floorList[0]?.imageid) {
          let matchingFloorImageObj;
          if (floorImages.length) {
            matchingFloorImageObj = floorImages.find(({ id: floorId }) => floorId === floorList[0].id);
          }
          if (!matchingFloorImageObj) {
            fetchFloorImage(floorList[0].id, floorList[0].imageid);
          } else {
            setFloorImage(matchingFloorImageObj?.imageUrl);
          }
        } else {
          setFloorImage(brokenImage2);
        }
      }
    } else if (floorList !== undefined) {
      // floorList is [] — loaded but no floors configured for this site
      setFloorImage(brokenImage2);
    }
    // floorList undefined = siteTagList still loading (page refresh) — wait for next run
  }, [floorId, floorList]);

  useEffect(() => {
    if (incidentActivity?.length) handleUserAndGroup();
  }, [userList, unNotifiedGroups, incidentActivity]);

  useEffect(() => {
    if (hasPermission("Live video feed", "View")) {
      setLiveFeedPermitted(true);
    }
    const activityLogs = (activityInfo) => {
      const tempOthers = [];
      const downloadedVideos = [];
      activityInfo?.forEach((activity) => {
        if (activity.action === "Resolved") {
          setResolved(activity);
          setDescription(activity?.description);
          setResolvedNote2(activity?.meta?.comment ?? "");
        } else if (activity.action === "Acknowledged") {
          setAcknowledged(activity?.description);
        } else if (activity.action === "Video Downloaded") {
          downloadedVideos.push({
            description: activity?.description,
            downloadTime: activity?.createdAt
          });
        } else if (activity.action === "Video Deleted") {
          setVideoDeleted(activity?.description);
        } else {
          setIncidentAction(activity?.action);
          tempOthers.push(activity);
        }
        setOthers(tempOthers);
      });
      setVideoDownloaded(downloadedVideos);
    };
    activityLogs(activityInfo);
  }, [incidentID, activityInfo]);

  // const getIncidentActivity = async () => {
  //   const incidentRes = await fetchIncidentActivity({
  //     ...evidenceData,
  //     activeSession
  //   });
  //   setIncidentActivity(incidentRes);
  // };
  const handleClickImageEvidence = async (evidence) => {
    const isImageEvidencePresent = evidence && (evidence?.id || evidence?.mediaId) && evidence?.mediaType === MEDIA_TYPES.IMAGE && evidence?.hasMedia === true;
    if (isImageEvidencePresent) {
      try {
        setIsImageLoading(true);
        setImageDownloadError(false);

        const cacheKey = evidence?.mediaId || evidence?.id;
        const cachedUrl = evidenceImages[cacheKey];
        if (cachedUrl) {
          setEvidenceImage({ mediaType: evidence?.mediaType, mediaUrl: cachedUrl });
          setImageDownloadError(false);
        } else if (evidence?.mediaId) {
          const url = await ImageDownloadMedia(evidence.mediaId, activeSession, "", "evidence");
          if (url) {
            dispatch(saveEvidenceImage(cacheKey, url));
            setEvidenceImage({ mediaType: evidence?.mediaType, mediaUrl: url });
            setImageDownloadError(false);
          } else {
            setImageDownloadError(true);
          }
        }
      } catch (error) {
        setIsImageLoading(false);
        setImageDownloadError(true);
        console.error("Error in handleClickImageEvidence:", error);
      } finally {
        setIsImageLoading(false);
      }
    }
  };

  const handleClickVideoEvidence = async (evidence) => {
    const isVideoEvidencePresent = evidence && (evidence?.id || evidence?.mediaId) && evidence?.mediaType === MEDIA_TYPES.VIDEO && evidence?.hasMedia === true;
    if (isVideoEvidencePresent) {
      try {
        setVideoLoader(true);
        setVideoDownloadError(false);

        if (evidence?.mediaId) {
          let s3Url = evidenceVideoUrls[evidence.mediaId];

          // Check if need to fetch (no cache or cached expired)
          if (!s3Url || !isS3UrlValid(s3Url)) {
            console.warn("S3 URL missing or expired, fetching fresh one");
            const freshUrl = (await fetchEvidenceS3Url(evidence.mediaId, activeSession))?.URL;
            if (freshUrl && isS3UrlValid(freshUrl)) {
              dispatch(saveEvidenceVideoUrl(evidence.mediaId, freshUrl));
              s3Url = freshUrl;
            } else {
              console.error("Unable to get valid S3 URL");
              setVideoDownloadError(true);
              return;
            }
          }

          if (s3Url) {
            setEvidenceVideo({ mediaType: evidence?.mediaType, mediaUrl: s3Url });
            setVideoDownloadError(false);
          } else {
            console.error("No valid S3 URL");
            setVideoDownloadError(true);
          }
        } else {
          setVideoDownloadError(true);
        }
      } catch (error) {
        setVideoLoader(false);
        setVideoDownloadError(true);
        console.error("Error in handleClickVideoEvidence:", error);
      } finally {
        setVideoLoader(false);
      }
    }
  };
  useEffect(() => {
    if (socketImageEvidence && !socketImageEvidence?.isMediaDeleted) {
      handleClickImageEvidence({ ...socketImageEvidence });
    }
    if (socketVideoEvidence && !socketVideoEvidence?.isMediaDeleted) {
      handleClickVideoEvidence({ ...socketVideoEvidence });
    }
  }, [evidenceData, socketVideoEvidence, socketImageEvidence]);


  const handleResolveIncident = async (notes, isAccurate) => {
    try {
      setResolveEventLoader(true);
      const updatedIncident = await updateSelectedIncident(
        {
          status: "Resolved",
          customdata: {
            comment: notes,
            accurate: isAccurate
          }
        },
        { id: incidentID },
        activeSession
      );
      setResolveApi(updatedIncident?.activity);
      setShowResolveEvents({ isOpen: false });
      setEventStatus(updatedIncident?.status);
      // Update resolved activity from API response so activityDateTime updates immediately
      const resolvedActivity = updatedIncident?.activity?.find(
        (act) => act?.action === "Resolved"
      );
      if (resolvedActivity) {
        setResolved(resolvedActivity);
        setDescription(resolvedActivity?.description);
        setResolvedNote2(resolvedActivity?.meta?.comment ?? "");
      }
    } catch (error) {
      setResolveEventLoader(false);
      setShowResolveEvents({ isOpen: false });
      const notificationInfo = {
        type: EVENTS_INFO_CONSTANTS.EVENT_NOT_RESOLVED_TYPE,
        priority: "critical",
        data: {
          subTitle: EVENTS_INFO_CONSTANTS.EVENT_NOT_RESOLVED_SUBTITLE
        },
        showNotification: true
      };
      dispatch(showNotificationBanner(notificationInfo));
    } finally {
      setResolveEventLoader(false);
    }
  };

  useEffect(() => {
    const { formatWithTime } = convertDateFormat(CreatedAt);
    setDateTime(formatWithTime);
    const { formatWithoutTime } = convertDateFormat(CreatedAt);
    setDate(formatWithoutTime);
  }, [stateData.createdAt]);

  useEffect(() => {
    if (resolved?.createdAt) {
      const { formatWithTime } = convertDateFormat(resolved.createdAt);
      setActivityDateTime(formatWithTime);
    }
  }, [resolved]);

  const handleUserAndGroup = () => {
    const activeUser = incidentActivity?.filter((item) => {
      const requestpayload = JSON.parse(item.requestpayload);
      return (
        (requestpayload?.incident?.status === "Acknowledged" ||
          requestpayload?.incident?.status === "Ack" ||
          requestpayload?.incident?.status === "Resolved") &&
        requestpayload?.resourceidentifier?.id === stateData?.evidence?.id
      );
    });
    if (activeUser?.length) {
      const userId = activeUser?.[0]?.userid;
      const requestpayload = JSON.parse(activeUser[0].requestpayload);
      const userDetails = userList?.filter((item) => item?.id === userId);
      const userGroup = unNotifiedGroups?.filter((item) => {
        return !!item?.users?.filter((user) => user.id === userId)?.length;
      });
      setUserDetails({
        id: userId,
        name: userDetails?.[0]?.notifierName,
        group: userGroup?.[0]?.notifierName,
        requestpayload: requestpayload
      });
    }
  };
  useEffect(() => {
    const activityLogs = (resolveApi) => {
      resolveApi?.forEach((activity) => {
        if (activity?.action === "Resolved") {
          setResolveDescription(activity?.description);
          setResolvedNote1(activity?.meta?.comment ?? "");
        }
      });
    };
    activityLogs(resolveApi);
  }, [resolveApi]);

  const altLayout = stateData?.evidenceStatus === 3 && stateData?.type === EVENT_TYPES.INCIDENT;
  const videoFailedComp = stateData?.evidenceStatus === 2 && stateData?.type === EVENT_TYPES.INCIDENT;
  const hasVideoAndImage =
    socketImageEvidence &&
    socketImageEvidence?.hasMedia === true &&
    socketImageEvidence?.mediaType === MEDIA_TYPES.IMAGE &&
    socketVideoEvidence &&
    socketVideoEvidence?.hasMedia === true &&
    socketVideoEvidence?.mediaType === MEDIA_TYPES.VIDEO;

  const hasOnlyImage =
    socketImageEvidence &&
    socketImageEvidence?.hasMedia === true &&
    socketImageEvidence?.mediaType === MEDIA_TYPES.IMAGE &&
    (!socketVideoEvidence || socketVideoEvidence?.hasMedia === false);

  const hasOnlyVideo =
    socketVideoEvidence &&
    socketVideoEvidence?.hasMedia === true &&
    socketVideoEvidence?.mediaType === MEDIA_TYPES.VIDEO &&
    (!socketImageEvidence || socketImageEvidence?.hasMedia === false);

  const noMedia = (!socketImageEvidence || socketImageEvidence?.hasMedia === false) && (!socketVideoEvidence || socketVideoEvidence?.hasMedia === false);
  const [snapshotImageUrl, setSnapshotImageUrl] = useState("");
  const [isSnapshotLoading, setIsSnapshotLoading] = useState(false);

  const fetchSnapshotImage = async (id, mediaId, mediaSource = "") => {
    try {
      setIsSnapshotLoading(true);
      const cacheKey = id;
      const cachedUrl = evidenceImages[cacheKey];
      if (cachedUrl) {
        setSnapshotImageUrl(cachedUrl);
        return;
      }
      // Gaurd: Handle missing ID immediately
      if (!id) {
        setSnapshotImageUrl("");
        return;
      }

      // Path A: Valid UUID (Fetch & Decode)
      if (UUID_REGEX.test(id)) {
        const evidenceRes = await fetchEvidenceDetails(`${id}`, activeSession);

        if (!evidenceRes) {
          setSnapshotImageUrl("");
          return;
        }

        const decodedImage = Base64VideoDecoder(JSON.parse(evidenceRes)?.media);
        dispatch(saveEvidenceImage(cacheKey, decodedImage));
        setSnapshotImageUrl(decodedImage);
        return;
      }

      // Path B: Non-UUID (Direct Download)
      const url = await ImageDownloadMedia(id, activeSession, "", mediaSource);
      if (url) {
        dispatch(saveEvidenceImage(cacheKey, url));
        setSnapshotImageUrl(url);
      } else {
        setSnapshotImageUrl("");
      }
    } catch (error) {
      console.error("Error downloading image:", error);
      setSnapshotImageUrl("");
    } finally {
      setIsSnapshotLoading(false);
    }
  };
  const snapshotMeta = useMemo(() => {
    const imageData = stateData?.evidences?.find((evidence) => evidence.mediaType?.toLowerCase() === MEDIA_TYPES.IMAGE && (evidence.id || evidence.mediaId));
    return {
      id: stateData?.snapshotId || imageData?.id,
      mediaId: stateData?.snapshotId ? undefined : imageData?.mediaId
    };
  }, [stateData?.snapshotId, stateData?.evidences]);


  useEffect(() => {
    if (snapshotMeta.id && (hasOnlyImage || hasVideoAndImage || noMedia)) {
      fetchSnapshotImage(snapshotMeta.id, undefined, "snapshot");
    }
  }, [snapshotMeta.id]);

 
  if (eventNotFound) {
    return (
      <Box sx={{ height: "500px" }}>
        <ErrorTemplate title={TEXT.EVENT_NOT_FOUND_ERROR} description={TEXT.EVENT_NOT_FOUND_DESC} onRefresh={() => navigate("/events")} />
      </Box>
    );
  }

  if (isError && !loading) {
    return (
      <>
        <div className="eventInfo_header">
          <Breadcrumbs surface="light">
            <BreadcrumbItem>
              <Link to="/events" className="breadcrums-item_link" data-testid="eventsInfo_navigateToEvents">
                Events{" "}
              </Link>
            </BreadcrumbItem>
          </Breadcrumbs>
        </div>
        <Box
          sx={{
            height: "500px",
            marginTop: "40px"
          }}
        >
          <ErrorTemplate title={TEXT.EVENTS_ERROR} description={TEXT.EVENTS_DETAILS_ERROR_DESC} onRefresh={() => fetchSingleIncidentDetails(incidentID)} />
        </Box>
      </>
    );
  } else {
    return (
      <>
        {stateData?.type === EVENT_TYPES.INCIDENT &&
          (hasOnlyImage || noMedia || (videoDownloadError && (hasOnlyVideo || hasVideoAndImage))) &&
          activeTabIndex === 0 &&
          stateData?.evidenceStatus !== 3 &&
          stateData?.evidenceStatus !== 0 &&
          (
            <Notification
              type={getNotificationBannerType(incidentCreatedBefore, hasOnlyImage, noMedia, videoDownloadError, hasOnlyVideo, hasVideoAndImage)}
              title={getNotificationBannerTitle({incidentCreatedBefore, hasOnlyImage, noMedia, videoDownloadError, hasOnlyVideo, hasVideoAndImage, incident:stateData})}
              priority="critical"
              showNotification={true}
              hideCloseButton={true}
              fullBleed={true}
            />
          )}

        <div className="eventInfo_header">
          <Breadcrumbs surface="light">
            {params.get("cameraId")?.trim() ? (
              <>
                <BreadcrumbItem>
                  <Link to="/devices" state={{ tabName: "Camera" }} className="breadcrums-item_link" data-testid="eventsInfo_navigateToCameras">
                    Cameras
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to={`/cameraInfoPage?cameraId=${encodeURIComponent(params.get("cameraId"))}`} className="breadcrums-item_link" data-testid="eventsInfo_navigateToCameraDetails">
                    Camera Details
                  </Link>
                </BreadcrumbItem>
              </>
            ) : (
              <BreadcrumbItem>
                <Link to="/events" className="breadcrums-item_link" data-testid="eventsInfo_navigateToEvents">
                  Events{" "}
                </Link>
              </BreadcrumbItem>
            )}
            <BreadcrumbItem>{getCVAppNameFromApplicationId(ApplicationId, cvAppList)}</BreadcrumbItem>
          </Breadcrumbs>
        </div>
        <ResolveEvents
          setShowResolveEvents={setShowResolveEvents}
          showResolveEvents={showResolveEvents}
          handleResolveIncident={handleResolveIncident}
          incidentId={incidentId}
          loader={resolveEventLoader}
        />

        {/*<ShareEvents
                setShowShareEvents={setShowShareEvents}
                showShareEvents={showShareEvents}
                setUnNotifiedGroups={setUnNotifiedGroups}
                unNotifiedGroups={unNotifiedGroups}
                userList={userList}
                setUserList={setUserList}
            /> */}
        {!loading && (<>
          <section className="eventInfo_header_section">
            <div className="eventInfo_header_flex">
              <Title size="large">{getCVAppNameFromApplicationId(ApplicationId, cvAppList)}</Title>
              <Badge fillColor={getPriorityColor(Priority)}>{Priority === "Low" || Priority === "Elevated" ? "Minor" : Priority}</Badge>
              {eventStatus && <Badge fillColor={getStatusColor(eventStatus)}>{eventStatus}</Badge>}
             
            </div>
            
            <div className="resolve_button">
              {!loading && eventStatus !== "Resolved" && (
                <Button
                  size="large"
                  use="primary"
                  disabled={eventStatus === "Resolved"}
                  data-testid="eventsInfo_resolveButton"
                  onClick={() => setShowResolveEvents({ isOpen: true })}
                >
                  Resolve
                </Button>
              )}
            </div>
            
          </section>
       </> )}
        <Loader active={loading} fullscreen={false} />
        {!loading && stateData &&  (
          <ResponsiveGrid altLayout={altLayout}>
           <Container1 statApp={widgetToFilter && widgetToFilter?.length > 0 ? true : false}>
              <div className="eventInfo-evidence-container">
              <EvidenceAndLiveFeedPlayer
                state={stateData}
                socketImageEvidence={socketImageEvidence}
                socketVideoEvidence={socketVideoEvidence}
                videoLoader={videoLoader}
                isImageLoading={isImageLoading}
                evidenceImage={evidenceImage}
                evidenceVideo={evidenceVideo}
                incidentId={incidentId}
                activeTabIndex={activeTabIndex}
                handleTabChange={handleTabChange}
                liveFeedPermitted={liveFeedPermitted}
                evidenceData={evidenceData ?? stateData?.evidences}
                fieldsData={fieldsData}
                liveFeedStyle={liveFeedStyle}
                dispatch={dispatch}
                showNotificationBanner={showNotificationBanner}
                cameraId={cameraId}
                widgetToFilter={widgetToFilter}
                videoFailedComp={videoFailedComp}
                hasOnlyVideo={hasOnlyVideo}
                hasOnlyImage={hasOnlyImage}
                hasVideoAndImage={hasVideoAndImage}
                noMedia={noMedia}
                snapshotImageUrl={snapshotImageUrl}
                videoDownloadError={videoDownloadError}
                incidentCreatedBefore={incidentCreatedBefore}
                onFetchFreshUrl={async () => {
                  const freshUrl = (await fetchEvidenceS3Url(socketVideoEvidence?.mediaId, activeSession))?.URL;
                  if (freshUrl && socketVideoEvidence?.mediaId) {
                    dispatch(saveEvidenceVideoUrl(socketVideoEvidence?.mediaId, freshUrl));
                  }
                  return freshUrl;
                }}
              />
              </div>
            </Container1>
            {activeTabIndex == 0 && (
              <Container2>
                <AccordionDetails
                  state={stateData}
                  imageUrl={snapshotImageUrl}
                  isImageLoading={isSnapshotLoading}
                  singleIncidentDetails={singleIncidentDetails}
                  cvappid={cvAppID}
                />
              </Container2>
            )}
            <Container3 altLayout={altLayout} statApp={widgetToFilter && widgetToFilter?.length > 0 ? true : false}>
              {floorImage === null ? (
                <div style={{ position: "relative", width: "100%", height: "300px" }}>
                  <Loader active={true} fullscreen={false} surface="light" />
                </div>
              ) : (
                <EbcFloorPlan
                  floorImage={floorImage}
                  cameras={getCamerabyId(cameraId)}
                  widgetSize={altLayout ? false : true}
                  showHazard={false}
                  isEditable={false}
                  eventData={stateData}
                  eventCheck={true}
                  top={stateData?.cameralocation?.top}
                  left={stateData?.cameralocation?.left}
                  altLayout={altLayout}
                  FloorSize={altLayout ? [829.19, 532.82] : null}
                  cameraId={cameraId}
                  fitToContainer
                />
              )}
            </Container3>
            <Container4 altLayout={altLayout}>
              <EventInfoContainer
                videoUploadSpeed={socketVideoEvidence?.uploadSpeed}
                date={date}
                CreatedAt={CreatedAt}
                stateData={stateData}
                LocationName={LocationName}
                isDetectionApp={isDetectionApp}
              />
            </Container4>

            <Container5 altLayout={altLayout}>
              <ActivityLogContainerComponent
                innerStyle={{}}
                eventStatus={eventStatus}
                resolveDescription={resolveDescription}
                description={description}
                activityDateTime={activityDateTime}
                resolvedNote1={resolvedNote1}
                resolvedNote2={resolvedNote2}
                videoDownloaded={videoDownloaded}
                title={title}
                stateData={stateData}
                dateTime={dateTime}
                cvappName={getCVAppNameFromApplicationId(ApplicationId, cvAppList)}
                cvappid={cvAppID}
                isDetectionApp={isDetectionApp}
                fovObject={fovObject}
                cameraData={cameraObject}
                companionObject={selCompanion}
                roiId={roiId}
                tagids={stateData?.tagids || []}
                deployments={stateData?.deploymentConfig || []}
                incidentId={incidentId}
              />
            </Container5>
          </ResponsiveGrid>
        )}
      </>
    );
  }
};
export default EventsInfo;
